import type { SVGProps } from "react";
export function ChevronDown(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m2.8178 5.47121c.20155-.18378.52835-.18378.72991 0l4.45226 4.05938 4.45223-4.05938c.2016-.18378.5284-.18378.7299 0 .2016.18377.2016.48173 0 .66551l-4.8172 4.39218c-.20156.1838-.52831.1838-.72987 0l-4.81723-4.39218c-.20156-.18378-.20156-.48174 0-.66551z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
